import React from 'react';
import { TextField } from 'rmwc/TextField';
import Calendar from 'react-calendar/dist/entry.nostyle';
import { FormatDate_MMM_d_yyyy } from '../lib/DateTimeFormatFunctions';


export class DateSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectorOpen: false
    }
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    //document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    //document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
       this.setState({selectorOpen:false});
    }
  }

  setWrapperRef(node) {
      this.wrapperRef = node;
  }

  onChange = date => {
    this.setState({selectorOpen:false});
    this.props.onChange(date);
  }

  render() {
    return (
      <div ref={this.setWrapperRef}>
        <TextField
          readOnly
          style={{width:"100px"}}
          label="Date"
          value={FormatDate_MMM_d_yyyy(this.props.date)}
          onClick={e => this.setState({'selectorOpen': !this.state.selectorOpen})}
        />
        {(this.state.selectorOpen)
        ?
        <div style={{zIndex:"1000", position:'absolute', width:"250px", backgroundColor:"red"}} >
          <Calendar
            onChange={this.onChange}
            value={new Date(this.props.date)}
          />
        </div>
        :
        null}
      </div>
    )
  }
}

/*
https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
*/



// WEBPACK FOOTER //
// ./src/components/DateSelector.js